export enum ViewType {
    Grid,
    List,
}
